module.exports = __webpack_public_path__ + "img/mq_2.7ff496f7.svg";